import { render, staticRenderFns } from "./Ipa.vue?vue&type=template&id=9d2e79c0&scoped=true&lang=pug&"
import script from "./Ipa.vue?vue&type=script&lang=js&"
export * from "./Ipa.vue?vue&type=script&lang=js&"
import style0 from "./Ipa.vue?vue&type=style&index=0&id=9d2e79c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2e79c0",
  null
  
)

export default component.exports